'use client';
import Image from 'next/image';
import Button from '@/components/ui/Button';
import Link from 'next/link';
import NewSpeakerSection from './NewSpeakerSection';



const EventsSection = () => {
  const upcomingEvents = [
  //  {
  //     src: "/images/events/web3-growth-forum.webp",
  //     alt: "Web3-growth-forum",
  //     href: "https://luma.com/261hw8lc"
  //   },
    {
      src: "/images/events/web3-growth-guild-abu-dhabi2026.webp",
      alt: "web3-growth-guild-abu-dhabi2026",
      href: "https://luma.com/Web3_growthguild?k=c"
    }
  ];

  const pastEvents = [
    {
      src: "/images/events/abu-dhabi-2025-event.webp",
      alt: "abu-dhabi-2025-event",
      href: "https://lu.ma/k906526b"
    },
    {
      src: "/images/events/web3-growth-guild-forum-singapore-luma.webp",
      alt: "web3-growth-guild-forum-singapore-luma",
      href: "https://luma.com/djqq7qqe"
    },
    {
      src: "/images/events/past-event-blockchain-fitness-brawlers-unite.webp",
      alt: "past-event-Blockchain-Fitness-Brawlers-Unite",
      href: "https://luma.com/blockchainbrawlers"
    },

    {
      src: "/images/events/past-event-the-builder-summit.webp",
      alt: "past-event-the-builder-summit",
      href: "https://luma.com/web3growthguild"
    },
        
  ];

  return (
    <section data-component-id="src/app/EventsSection.tsx:49:4" data-component-path="src/app/EventsSection.tsx" data-component-line="49" data-component-file="EventsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22events%22%2C%22className%22%3A%22w-full%20py-12%22%7D" id="events" className="w-full py-12">
      {/* Main Title */}
      <div data-component-id="src/app/EventsSection.tsx:51:6" data-component-path="src/app/EventsSection.tsx" data-component-line="51" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-4%20items-center%20text-center%20px-4%20sm%3Apx-6%20lg%3Apx-0%20max-w-3xl%20mx-auto%20mb-10%22%7D" className="flex flex-col gap-4 items-center text-center px-4 sm:px-6 lg:px-0 max-w-3xl mx-auto mb-10">
        <h2 data-component-id="src/app/EventsSection.tsx:52:8" data-component-path="src/app/EventsSection.tsx" data-component-line="52" data-component-file="EventsSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B28px%5D%20sm%3Atext-%5B36px%5D%20md%3Atext-%5B46px%5D%20lg%3Atext-%5B56px%5D%20font-bold%20font-satoshi%20leading-tight%20bg-gradient-to-b%20from-black%20to-gray-500%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Events%20%26%20Initiatives%22%7D" className="text-[28px] sm:text-[36px] md:text-[46px] lg:text-[56px] font-bold font-satoshi leading-tight bg-gradient-to-b from-black to-gray-500 bg-clip-text text-transparent">
          Events & Initiatives
        </h2>
      </div>

      {/* ---------- UPCOMING EVENTS ---------- */}
      <div data-component-id="src/app/EventsSection.tsx:58:6" data-component-path="src/app/EventsSection.tsx" data-component-line="58" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1240px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-0%20mb-16%20text-center%22%7D" className="w-full max-w-[1240px] mx-auto px-4 sm:px-6 lg:px-0 mb-16 text-center">
        <h3 data-component-id="src/app/EventsSection.tsx:59:8" data-component-path="src/app/EventsSection.tsx" data-component-line="59" data-component-file="EventsSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B22px%5D%20sm%3Atext-%5B28px%5D%20md%3Atext-%5B34px%5D%20lg%3Atext-%5B40px%5D%20font-satoshi%20font-bold%20leading-tight%20mb-8%20bg-%5Blinear-gradient(175deg%2C%23000000_0%25%2C_%232626267f_100%25)%5D%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Upcoming%20Events%22%7D" className="text-[22px] sm:text-[28px] md:text-[34px] lg:text-[40px] font-satoshi font-bold leading-tight mb-8 bg-[linear-gradient(175deg,#000000_0%,_#2626267f_100%)] bg-clip-text text-transparent">
          Upcoming Events
        </h3>

        {/* <div className="grid grid-cols-2 sm:grid-cols-2 gap-6 sm:gap-8 justify-center"> */}
      <div data-component-id="src/app/EventsSection.tsx:64:6" data-component-path="src/app/EventsSection.tsx" data-component-line="64" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20gap-10%22%7D" className="flex justify-center gap-10">
          {upcomingEvents.map((event, index) => (
            <a data-component-id="src/app/EventsSection.tsx:66:12" data-component-path="src/app/EventsSection.tsx" data-component-line="66" data-component-file="EventsSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
              key={index}
              href={event.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              <Image data-component-id="src/app/EventsSection.tsx:72:14" data-component-path="src/app/EventsSection.tsx" data-component-line="72" data-component-file="EventsSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-%5B24px%5D%20w-%5B340px%5D%20object-cover%20transition-transform%20duration-200%20hover%3Ascale-105%22%7D"
                src={event.src}
                alt={event.alt}
                width={600}
                height={400}
                className="rounded-[24px] w-[340px] object-cover transition-transform duration-200 hover:scale-105"
                unoptimized
              />
            </a>
          ))}
        </div>
      </div>

      {/* ---------- SPEAKERS ---------- */}
      
      {/* <NewSpeakerSection /> */}
      
      {/* ---------- PAST EVENTS ---------- */}
      <div data-component-id="src/app/EventsSection.tsx:90:6" data-component-path="src/app/EventsSection.tsx" data-component-line="90" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1240px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-0%20mb-16%20text-center%22%7D" className="w-full max-w-[1240px] mx-auto px-4 sm:px-6 lg:px-0 mb-16 text-center">
        <h3 data-component-id="src/app/EventsSection.tsx:91:8" data-component-path="src/app/EventsSection.tsx" data-component-line="91" data-component-file="EventsSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B22px%5D%20sm%3Atext-%5B28px%5D%20md%3Atext-%5B34px%5D%20lg%3Atext-%5B40px%5D%20font-satoshi%20font-bold%20leading-tight%20mb-8%20bg-%5Blinear-gradient(175deg%2C%23000000_0%25%2C_%232626267f_100%25)%5D%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Past%20Events%22%7D" className="text-[22px] sm:text-[28px] md:text-[34px] lg:text-[40px] font-satoshi font-bold leading-tight mb-8 bg-[linear-gradient(175deg,#000000_0%,_#2626267f_100%)] bg-clip-text text-transparent">
          Past Events
        </h3>

        <div data-component-id="src/app/EventsSection.tsx:95:8" data-component-path="src/app/EventsSection.tsx" data-component-line="95" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-4%20gap-6%20sm%3Agap-8%20justify-center%22%7D" className="grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 justify-center">
          {pastEvents.map((event, index) => (
            <a data-component-id="src/app/EventsSection.tsx:97:12" data-component-path="src/app/EventsSection.tsx" data-component-line="97" data-component-file="EventsSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
              key={index}
              href={event.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              <Image data-component-id="src/app/EventsSection.tsx:103:14" data-component-path="src/app/EventsSection.tsx" data-component-line="103" data-component-file="EventsSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-%5B24px%5D%20w-full%20object-cover%20transition-transform%20duration-200%20hover%3Ascale-105%22%7D"
                src={event.src}
                alt={event.alt}
                width={600}
                height={400}
                className="rounded-[24px] w-full object-cover transition-transform duration-200 hover:scale-105"
                unoptimized
              />
            </a>
          ))}
        </div>
      </div>

      {/* ---------- HOST BUTTON ---------- */}
      <div data-component-id="src/app/EventsSection.tsx:117:6" data-component-path="src/app/EventsSection.tsx" data-component-line="117" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%22%7D" className="flex justify-center">
        <Link data-component-id="src/app/EventsSection.tsx:118:8" data-component-path="src/app/EventsSection.tsx" data-component-line="118" data-component-file="EventsSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fcontact%2F%22%7D" href="/contact/">
          <Button data-component-id="src/app/EventsSection.tsx:119:10" data-component-path="src/app/EventsSection.tsx" data-component-line="119" data-component-file="EventsSection.tsx" data-component-name="Button" data-component-content="%7B%22elementName%22%3A%22Button%22%2C%22className%22%3A%22pt-%5B10px%5D%20pr-%5B12px%5D%20pb-%5B10px%5D%20pl-%5B24px%5D%20flex%20items-center%20gap-2%22%7D"
            text="Host an Event With Us"
            className="pt-[10px] pr-[12px] pb-[10px] pl-[24px] flex items-center gap-2"
          />
        </Link>
      </div>
    </section>
  );
};

export default EventsSection;
